import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHydrocortisoneGlyphSecondary from './svgs/HydrocortisoneGlyphSecondary.js';
import SvgHydrocortisoneGlyph from './svgs/HydrocortisoneGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var hydrocortisoneGlyph = (props => useIcon(SvgHydrocortisoneGlyph, SvgHydrocortisoneGlyphSecondary, props));

export { hydrocortisoneGlyph as default };
